import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationOidcService } from '../../services/authentication-oidc-service';
import { environment } from '../../../environments/environment';
import { FromProviderType } from '../../interfaces/from-type-enum';

const providerTypeStorageKey = environment.PROVIDER_TYPE_STORAGE_KEY;

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.html',
  styleUrls: ['./redirect.scss'],
})
export class RedirectComponent {
  fromProviderType: FromProviderType | null = null;

  constructor(
    private authenticationOidcService: AuthenticationOidcService,
    private router: Router,
  ) {
    sessionStorage.clear();

    // Determine provider type based on the route
    const url = this.router.url;
    const providerType = this.determineProviderType(url);
    if (!providerType) {
      this.router.navigate(['/unauthorized']);
      return;
    }

    // Handle /redirect or /redirect/b2c
    sessionStorage.setItem(providerTypeStorageKey, providerType);
    this.authenticationOidcService.login(providerType);
  }

  /**
   * Determines the provider type based on the current route
   * @param url Current route URL
   * @returns FromProviderType or null based on route
   */
  private determineProviderType(url: string): FromProviderType | null {
    switch (url) {
      case '/redirect/suiteedge':
        return FromProviderType.SUITEEDGE;
      case '/redirect/imperia':
        return FromProviderType.IMPERIA;
      default:
        return null;
    }
  }
}
